<template>
    <div class="text-center">
        <div v-if="currentStep === 1">
            <p class="ios-modal-text mb-4">
                For an uninterrupted workout you'll need to
                <strong>stop your iPhone going to sleep!</strong>
            </p>
            <div class="circle-number">1</div>
            <h4 class="my-3">Open Settings</h4>
            <img src="ios-settings.png" alt="iOS Settings Icon" />
        </div>
        <div v-if="currentStep === 2">
            <div class="circle-number mb-3">2</div>
            <p class="ios-modal-text mb-4">
                Select and open
                <strong>Display & Brightness</strong>
            </p>
            <img src="ios-settings-2.png" alt="iOS Settings - Display & Brightness" />
        </div>
        <div v-if="currentStep === 3">
            <div class="circle-number mb-3">3</div>
            <p class="ios-modal-text mb-4">
                Select and open
                <strong>Auto-Lock</strong>
            </p>
            <img src="ios-settings-3.png" alt="iOS Settings - Auto-Lock" />
        </div>
        <div v-if="currentStep === 4">
            <div class="circle-number mb-3">4</div>
            <p class="ios-modal-text mb-4">
                Select
                <strong>Never</strong>
            </p>
            <img src="ios-settings-4.png" alt="iOS Settings - Auto-Lock - Never" />
        </div>
        <div v-if="currentStep === totalSteps">
            <h1 class="font-weight-bold">YOU'RE DONE!</h1>
            <p>
                <strong>Safety Notice:</strong>
                <br />Physical activity is not suitable for everyone and could result in injury. Please consult with a doctor before starting any physical activity.
            </p>
            <p>Make sure you warm up before starting and if you experience any discomfort during your workout stop immediately!</p>
        </div>
        <div class="mt-3">
            <button v-if="currentStep !== totalSteps" class="modal-button" @click="nextStep()">NEXT</button>
            <button v-else class="modal-button" @click="close()">CLOSE</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "IOSModalBody",
        props: {
            close: Function
        },
        methods: {
            nextStep: function() {
                this.currentStep++;
            }
        },

        data: function() {
            return {
                currentStep: 1,
                totalSteps: 5
            };
        }
    };
</script>

<style lang="scss">
    .circle-number {
        display: inline-block;
        background-color: #222;
        color: #fff;
        width: 30px;
        height: 30px;
        font-size: 18px;
        line-height: 32px;
        text-align: center;
        font-weight: bold;
        border-radius: 50%;
    }

    .ios-modal-text {
        font-size: 1.25rem;
    }

    .modal-button {
        display: inline-block;
        background-color: #222;
        color: #fff;
        min-width: 100%;
        padding: 10px;
        font-size: 18px;
        text-align: center;
        font-weight: bold;
        border: none;
        border-radius: 15px;
        transition: 0.3s;

        &:focus,
        &:hover {
            outline: none;
            background-color: #333;
        }
    }
</style>
